import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Image,
  Button,
  Accordion,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import LogisticPartnerAuth from "../../../auth/LogisticPartnerAuth";
import { getLogisticPartners } from "../../../../actions/user.actions";
import PageSpinner from "../../../common/PageSpinner";
import { tableStructures } from "../../../../helpers/table-structures";
import CustomTable from "../CustomTable";
import { stringConstants } from "../../../../helpers";
import { updateUserStatus } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";

const LogisticPartner = ({
  fromOnboarding = false,
  fromSubscriptionUpgrade = false,
  setOnboardingLpList,
}) => {
  const dispatch = useDispatch();
  const refFilter = useRef([]);
  const refMobileFilter = useRef([]);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lpList, setLpList] = useState([]);

  const { auth, requestCall } = useSelector((state) => {
    return state;
  });

  const handleScrollView = () => {
    if (window.scrollY !== 0) {
      if (window.innerWidth < 768) {
        refMobileFilter.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      } else {
        refFilter.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }
  };

  useEffect(() => {
    if (auth?.user?.id) {
      loadLPList(auth, dispatch);
    }
  }, [auth, dispatch]);

  const loadLPList = (auth, dispatch) => {
    setLoading(true);
    getLogisticPartners(auth?.user?.id, auth?.user?.role?.role_name, dispatch)
      .then((res) => {
        setLpList(res.data);
        if (fromOnboarding) {
          setOnboardingLpList(res.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading && <PageSpinner />}
      <section className="logistic-partner-main-section">
        <div className="p-0 mb-3">
          {isCreateMode || lpList?.length <= 0 ? (
            <>
              <LogisticPartnerAuth
                fromRegister={true}
                fromSubscriptionUpgrade={fromSubscriptionUpgrade}
                closeButtonFunction={() => {
                  setIsCreateMode(false);
                  setIsUpdateMode(false);
                  handleScrollView();
                  loadLPList(auth, dispatch);
                }}
              />
            </>
          ) : (
            <>
              <Row className="m-0">
                <Col md={6} className="text-start mt-3">
                  <div className="table-heading-wrap">
                    <h4>Logistic Partners</h4>
                  </div>
                </Col>
                <Col md={6} className="text-end mt-3">
                  <Button
                    className="btn-theme"
                    onClick={() => {
                      setIsCreateMode(true);
                    }}
                  >
                    <i className="bi bi-plus-lg"></i> Add
                  </Button>
                </Col>
              </Row>
              <Row className="m-0">
                <Col md={12} className="px-0">
                  <CustomTable
                    columns={tableStructures.user_list_lp}
                    data={lpList}
                    enableRowActions={true}
                    positionActionsColumn={"last"}
                    enableTopToolbar={false}
                    emptyTableMsg={"No data found."}
                    enablePagination={true}
                    enableBottomToolbar={true}
                    enableFilters={true}
                    renderRowActions={({ row }) => (
                      <div className="table-action-box">
                        <Button
                          variant="primary"
                          onClick={() => {
                            dispatch({
                              type: stringConstants.SET_CURRENT_VIEW,
                              payload: stringConstants.USER_DETAILS,
                              currentViewId: row.original.id,
                              currentViewObj: row.original,
                            });
                          }}
                        >
                          <i className="bi bi-eye"></i>
                        </Button>
                        &nbsp;
                        {row.original.status === 1 ? (
                          <Button
                            variant="danger"
                            onClick={() =>
                              updateUserStatus(row.original.id, dispatch, "logistic_partner")
                            }
                            disabled={requestCall?.loading}
                          >
                            <i class="bi bi-slash-circle"></i>
                          </Button>
                        ) : (
                          <Button
                            variant="success"
                            onClick={() =>
                              updateUserStatus(row.original.id, dispatch, "logistic_partner")
                            }
                            disabled={requestCall?.loading}
                          >
                            <i class="bi bi-check-circle"></i>
                          </Button>
                        )}
                      </div>
                    )}
                    renderTopToolbarCustomActions={() => (
                      <div className="table-heading-wrap">
                        <h4>Logistic Partners</h4>
                      </div>
                    )}
                    initialState={{
                      columnPinning: {
                        right: ["mrt-row-actions"],
                      },
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default LogisticPartner;
